import cloneDeep from 'lodash.clonedeep';
import {
    FormTemplate,
    FormTemplateSection,
} from 'data/template/template.types';

export function adaptTemplateVisibilityMode(
    template: FormTemplate | undefined,
    mode: 'create' | 'edit' | 'view' | 'copy',
): FormTemplate | undefined {
    if (template == null) {
        return;
    }

    const clonedTemplate = cloneDeep(template);

    if (mode === 'edit') {
        (clonedTemplate.main as FormTemplateSection).fields.SS8ID.readOnly = true;
    } else if (mode === 'view') {
        setAllFieldsAsReadOnlyExcludingFields(clonedTemplate, []);
    }

    return clonedTemplate;
}

function setAllFieldsAsReadOnlyExcludingFields(template: FormTemplate, excludingFields: string[]) {
    Object.entries(template).forEach(([_templateKey, templateEntry]) => {
        if (typeof templateEntry === 'string') {
            return;
        }
        Object.entries(templateEntry.fields).forEach(([fieldKey, fieldEntry]) => {
            if (!excludingFields.includes(fieldKey)) {
                fieldEntry.readOnly = true;
            }
        });
    });
}
